import Image from "next/image"
import CallToAction from "./CallToAction"
import track from "utilities/track"

export default function OurStory({}) {
  return (
    <section className="px-5 py-10 lg:py-14">
      <div className="mx-auto max-w-screen-xl">
        <div className="flex flex-col md:flex-row gap-5 md:items-center">
          <div className="md:basis-1/2">
            <Image src="/assets/about.webp" alt="The White House" height={400} width={600} />
          </div>
          <div className="md:basis-1/2">
            <div className="eyebrow text-primary pb-2">OUR STORY</div>
            <h2 className="text-primary">25 Years of Federal News Network</h2>
            <p className="py-4">
              Innovation has defined the 21st century. Since 2000, Federal News Network has evolved too — from the first
              internet-only news radio station focused on the government into a powerful multiplatform outlet. Despite
              the many technological and cultural shifts, our mission remains unchanged: Help federal managers meet
              their mission by bringing government and Industry together to share knowledge, address challenges and
              tackle the issues that matter most.
            </p>
            <h4 className="text-primary pb-4">Keep up with the news that matters in our daily newsletter</h4>
            <CallToAction
              href="https://federalnewsnetwork.com/sailthru-newsletters-signup/"
              style="primary"
              target="_blank"
              onClick={() => track({ event: "click_newsletter_signup" })}
            >
              SIGN UP NOW
            </CallToAction>
          </div>
        </div>
      </div>
    </section>
  )
}
